import { shallowEqual } from 'react-redux';

export default (prevProps, nextProps) => shallowEqual(prevProps, nextProps);
